import { render, staticRenderFns } from "./LayoutSample.vue?vue&type=template&id=4a4dc91a&"
import script from "./LayoutSample.vue?vue&type=script&lang=js&"
export * from "./LayoutSample.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSample.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports